import { createClient } from "@supabase/supabase-js";

const AUTH_API_BASE = import.meta.env.VITE_BASE_AUTH_API_URL;
const SUPABASE_PROXY_BASE = `${AUTH_API_BASE}/proxy`;
const SUPABASE_ANON_KEY_PLACEHOLDER = "sb_publishable_placeholder";

const proxyFetch: typeof fetch = async (input, init) => {
  const urlString = input instanceof Request ? input.url : input.toString();

  if (urlString.startsWith(SUPABASE_PROXY_BASE)) {
    return fetch(input, {
      ...init,
      credentials: "include",
      headers: {
        ...init?.headers,
        Accept: "application/json",
        "X-Client": "dashboards",
        "X-Client-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
        "X-Client-Version": __BUILD_VERSION__,
      },
    });
  }

  return fetch(input, init);
};

export const supabase = createClient(
  SUPABASE_PROXY_BASE,
  SUPABASE_ANON_KEY_PLACEHOLDER,
  {
    global: { fetch: proxyFetch },
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false,
    },
  },
);
